/**
 * Centralized configuration constants
 */

// Classification: LLM is primary, rule-based is emergency fallback only
export const LLM_PRIMARY_MODE_ENABLED = process.env.REACT_APP_LLM_PRIMARY_MODE === 'true'

/**
 * Log when rule-based fallback is triggered (LLM failed)
 * This helps monitor LLM reliability
 */
export function logClassificationFallback(
  reason: 'llm_null_result' | 'llm_error',
  identifier: string,
  error?: unknown
): void {
  const message = `[Classification Fallback] reason=${reason} id=${identifier}`

  if (error) {
    console.warn(message, error)
  } else {
    console.warn(message)
  }

  // TODO: Add analytics tracking here if needed
  // e.g., analytics.track('classification_fallback', { reason, identifier })
}
